/**
 * Test IDs for QA automation.
 */
export const testIds = {
  maintenanceTaskFormLabel: "maintenance-task-form-label",
  maintenanceTaskFormRequired: "maintenance-task-form-required",
  maintenanceTaskFormRecurring: "maintenance-task-form-recurring",
  maintenanceTaskFormSave: "maintenance-task-form-save",
} as const;
